import React, { useState } from 'react'
import CaseImg from '../../images/stepvest.png'
import CaseImg2 from '../../images/Munch-on home.png'
import CaseImg3 from '../../images/collegepur.png'
import CaseImg4 from '../../images/to-do.png'
import { Link } from 'react-router-dom'

const CaseCard = ({ id, title, img, link, customClass, external }) => {
  const content = (
    <>
      <div className="case-img">
        <img src={img} alt={title} />
      </div>
      <p className="case-title title">{title}</p>
    </>
  );

  return external ? (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className={`case-right-box ${customClass}`}
    >
      {content}
    </a>
  ) : (
    <Link
      to={`/case-study/${id}`}
      className={`case-right-box ${customClass}`}
    >
      {content}
    </Link>
  );
};


function CaseStudy() {
  const [selectedCase, setSelectedCase] = useState(null);
  const cards = [
  {
    id: 1,
    title: "StepVest",
    img: CaseImg,
    customClass: "stepvest",
    external: true,
    link: "https://www.behance.net/gallery/228597219/StepVest-A-Invest-learning-plateform"
  },
  {
    id: 2,
    title: "MunchOn",
    img: CaseImg2,
    customClass: "munchon",
    external: true,
    link: "https://www.behance.net/gallery/225984345/MunchOn-A-snack-ordering-app-for-movie-theater"
  },
  {
    id: 3,
    title: "CollegePur",
    img: CaseImg3,
    customClass: "collegepur",
    external: false
  },
  {
    id: 4,
    title: "To-Do List",
    img: CaseImg4,
    customClass: "todo",
    external: false
  }
];




  const handleClick = (id) => {
    setSelectedCase({ id });
    console.log(`'card-clicked' : ${id}`)
  }
  return (
    <main className='case-study'>
      <div className="ml-72">
        <div className="case-main pt-48 timeLine">
          <div className="case-left timeLine-item ">
            <h3 className="title">
              Design Case Study and UI challenges
            </h3>
            <p className="detail-para case-para">Each case study in my portfolio reflects a complete design process — from understanding user needs to testing high-fidelity prototypes. I follow the Design Thinking approach, starting with empathizing with users, defining clear problems, ideating user-centered solutions, prototyping in Figma, and testing for usability and accessibility.</p>
            <ul className="list-work">
              <h3 className="list-heading">My case studies include:
              </h3>
              <li> StepVest: Investment Learning Platform – Built to educate beginners in personal finance using clear navigation and interactive learning tools.
              </li>
              <li>MunchOn: Snack Ordering App for Theaters – Designed to reduce queues and simplify ordering through a mobile-first experience.                    </li>
              <li>CollegePur: College Info & Resume Builder Platform (Internship Project) – A responsive web solution offering centralized college information, scholarships, and resume-building tools, created with a collaborative design team.</li>
              <li>Ongoing Redesign Projects – Focused on improving usability and visual hierarchy in existing digital products.</li>
            </ul>
            <p>Each project demonstrates my ability to design with both aesthetic sensibility and technical feasibility, ensuring user-friendly experiences that work in the real world.</p>
          </div>

          <div className="case-right">
            {cards.map(card => (
              <CaseCard
                key={card.id}
                id={card.id}
                title={card.title}
                img={card.img}
                link={card.link}
                customClass={card.customClass}
                external={card.external}
              />
            ))}
          </div>

        </div>
      </div>
    </main>
  )
}

export default CaseStudy